import React from "react";
import { Clock, Store } from "lucide-react";

interface HeaderProps {
  dateLabel: string;
  selectedLojaId?: number;
  selectedLojaNome?: string;
}

export const Header: React.FC<HeaderProps> = ({
  dateLabel,
  selectedLojaId,
  selectedLojaNome,
}) => {
  return (
    <div className="mt-6 px-4 py-4 text-center sm:py-6">
      <h1 className="mb-2 bg-gradient-to-r from-yellow-300 to-white bg-clip-text text-2xl font-black text-transparent sm:text-3xl md:text-4xl lg:text-5xl">
        FILA DE ENTREGAS
      </h1>
      <div className="mb-3 flex items-center justify-center gap-2 text-sm opacity-75 sm:text-lg">
        <Clock className="h-3 w-3 sm:h-4 sm:w-4" />
        <span>{dateLabel}</span>
        {selectedLojaId && selectedLojaNome && (
          <>
            <span className="mx-2">•</span>
            <Store className="h-3 w-3 sm:h-4 sm:w-4" />
            <span>{selectedLojaNome}</span>
          </>
        )}
      </div>
    </div>
  );
};
